import { v4 as uuidv4 } from 'uuid';
import { MarcacaoOffline, MarcacaoOfflineResponse } from '@/assets/ts/interfaces/Offline';
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import OfflineController from '@/assets/ts/controller/OfflineController';

interface UpdateChaveMarcacao {
  NRMARCACAOOFFLINE: string;
  NRCHAVEVINCULO: string;
}

class MarcacaoRepository {

  public static async getMarcacoes(): Promise<MarcacaoOffline[]> {
    try {

      const db = OfflineController.getDB();
      const marcacoes = await new Promise<any[]>((resolve, reject) => {
        db.transaction((tx) => {
          tx.executeSql(
            `SELECT *, 
              CASE IDSINCRONIZADO
                  WHEN 'S' THEN 'Sincronizado'
                  WHEN 'N' THEN 'Não sincronizado'
                  ELSE 'Pendente' 
              END AS DSSINCRONIZADO 
            FROM GPE_MARCACAOPONTO`,
            [],
            (tx, res) => {
              const marcacoesRow = [];
              for (let i = 0; i < res.rows.length; i++) {
                marcacoesRow.push(res.rows.item(i));
              }
              resolve(marcacoesRow);
          });
        });
      });

      return marcacoes;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async setMarcacao(
    marcacoes: MarcacaoOffline
  ): Promise<any> {
    try {
      const NRMARCACAOOFFLINE = uuidv4();
      const IDSINCRONIZADO = 'P';
      const { NRCHAVEVINCULO, NMVINCULOM, DTHRMARCACAOPONTO, IDALMOCO, DSLATITUDE, DSLONGITUDE, DSPATH, DSERROMARCACAO } = marcacoes;

      const db = OfflineController.getDB();
      return new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            tx.executeSql(
              'INSERT INTO GPE_MARCACAOPONTO (NRMARCACAOOFFLINE, NRCHAVEVINCULO, NMVINCULOM, DTHRMARCACAOPONTO, IDALMOCO, IDSINCRONIZADO, DSLATITUDE, DSLONGITUDE, DSPATH, DSERROMARCACAO) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)',
              [NRMARCACAOOFFLINE, NRCHAVEVINCULO, NMVINCULOM, DTHRMARCACAOPONTO, IDALMOCO, IDSINCRONIZADO, DSLATITUDE, DSLONGITUDE, DSPATH, DSERROMARCACAO]
            );
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve(true);
          }
        );
      });
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async deleteMarcacoes(
    marcacoes: MarcacaoOfflineResponse[]
  ): Promise<any> {
    try {

      const ids = marcacoes.map((marc) => marc.NRMARCACAOOFFLINE);
      const placeholders = ids.map(() => '?').join(',');
      const db = OfflineController.getDB();

      const result = await new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            tx.executeSql(`DELETE FROM GPE_MARCACAOPONTO WHERE NRMARCACAOOFFLINE IN (${placeholders})`, ids);
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve('');
          }
        );
      });

      return result;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async getMarcacoesByChaves(NRVINCULOM: string, NRCPFPESSOA?: string): Promise<MarcacaoOffline[]> {
    try {
      const db = OfflineController.getDB();

      const marcacoes = await new Promise<any[]>((resolve, reject) => {
        db.transaction((tx) => {
          const query = NRCPFPESSOA
            ? 'SELECT * FROM GPE_MARCACAOPONTO WHERE NRCHAVEVINCULO = ? OR NRCHAVEVINCULO = ?'
            : 'SELECT * FROM GPE_MARCACAOPONTO WHERE NRCHAVEVINCULO = ?';

          const params = NRCPFPESSOA ? [NRVINCULOM, NRCPFPESSOA] : [NRVINCULOM];

          tx.executeSql(query, params, (tx, res) => {
            const marcacoesRow = [];
            for (let i = 0; i < res.rows.length; i++) {
              marcacoesRow.push(res.rows.item(i));
            }
            resolve(marcacoesRow);
          });
        });
      });

      return marcacoes;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async updateMarcacoes(
    marcacoes: MarcacaoOfflineResponse[]
  ): Promise<any> {
    try {

      const db = OfflineController.getDB();
      return new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            marcacoes.forEach((marcacao) => {
              const { NRMARCACAOOFFLINE, NMVINCULOM, DSERROMARCACAO } = marcacao;
              const IDSINCRONIZADO = "N";
              const NMVINCULOFINAL = NMVINCULOM ? NMVINCULOM : 'Não Encontrado'; 

              tx.executeSql(
                'UPDATE GPE_MARCACAOPONTO SET DSERROMARCACAO = ?, IDSINCRONIZADO = ?, NMVINCULOM = ? WHERE NRMARCACAOOFFLINE = ?',
                [DSERROMARCACAO, IDSINCRONIZADO, NMVINCULOFINAL, NRMARCACAOOFFLINE]
              );

            });
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve(true);
          }
        );
      });
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async updateChaveMarcacao(
    marcacao: UpdateChaveMarcacao
  ): Promise<any> {
    try {

      const { NRMARCACAOOFFLINE, NRCHAVEVINCULO } = marcacao;
      const db = OfflineController.getDB();

      return new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            tx.executeSql(
              'UPDATE GPE_MARCACAOPONTO SET NRCHAVEVINCULO = ? WHERE NRMARCACAOOFFLINE = ?',
              [ NRCHAVEVINCULO, NRMARCACAOOFFLINE]
            );
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve(true);
          }
        );
      });
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async deleteMarcacaoById(
    NRMARCACAOOFFLINE: string
  ): Promise<any> {
    try {
      const db = OfflineController.getDB();

      return new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            tx.executeSql(
              'DELETE FROM GPE_MARCACAOPONTO WHERE NRMARCACAOOFFLINE = ?',
              [ NRMARCACAOOFFLINE ]
            );
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve(true);
          }
        );
      });
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }
}

export default MarcacaoRepository;
